import { EngagementItem } from "PFApp/components/engagement_item";
import { TemplateKey } from "PFApp/constants/templates";
import { Select, SelectCommonProps } from "PFComponents/select";
import { fetchActivities } from "PFCore/services/activities";
import { Activity, Id } from "PFTypes";

type EngagementSelectorProps = Omit<SelectCommonProps<Activity>, "renderDisplayValue" | "fetchOptions"> & {
  isAudit: boolean;
  value?: Id;
};

export const EngagementSelector = ({ isAudit, value, ...selectProps }: EngagementSelectorProps) => {
  const engagementKey = isAudit ? TemplateKey.AuditEngagement : TemplateKey.Engagement;

  const fetchOptions = async ({ ids, searchTerm }: { ids?: Id[]; searchTerm?: string }) => {
    const filters = ids?.length
      ? { fields: { id: ids } }
      : {
          fields: {
            term: searchTerm,
            template_key: engagementKey,
            state: ["draft", "new"]
          }
        };
    const response = await fetchActivities({ filters });
    const entries = response.entries.map((entry) => ({
      id: entry.activity.id,
      value: entry.activity.name,
      displayElement: (
        <EngagementItem
          item={{
            id: entry.activity.id,
            name: entry.activity.name,
            isPrivate: entry.activity.private
          }}
        />
      ),
      original: entry.activity
    }));
    return { ...response, entries };
  };

  return (
    <Select<Activity>
      id="parent_activity_select"
      {...selectProps}
      value={value}
      renderDisplayValue={(option) => option?.displayElement}
      fetchOptions={fetchOptions}
    />
  );
};
